type Options = {
  defaultValue?: boolean;
};

export const toBoolean = (
  data: any,
  { defaultValue }: Options = {}
): boolean => {
  if (data !== 'oui' && data !== 'non') {
    return !!defaultValue;
  }

  return data === 'oui';
};

export const toBooleanFromProp = (
  propName: string,
  data: any,
  options: Options = {}
): boolean => toBoolean(data?.[propName], options);
